import React from "react";
import { getValue } from "@utils/lodash";

function DropdownArrowSvgComponent(props: any) {
  return (

    <svg xmlns="http://www.w3.org/2000/svg"
    height={
        getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
    }
    width={
        getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
    }
     viewBox="0 0 24 24">
    <defs>
    <clipPath id="clip-path-dd-arrow">
        <rect id="Rectangle_18311" data-name="Rectangle 18311" width="24" height="24" transform="translate(-15602 -7486)" fill="#fff"/>
    </clipPath>
    </defs>
    <g id="Mask_Group_381" data-name="Mask Group 381" transform="translate(15602 7486)" clip-path="url(#clip-path-dd-arrow)">
    <path id="arrow_drop_down_FILL0_wght300_GRAD0_opsz24_1_" data-name="arrow_drop_down_FILL0_wght300_GRAD0_opsz24 (1)" d="M25.7-32.468l-5-5h10Z" transform="translate(-15615.699 -7438.532)" fill={
        getValue(props, `color`, "") ? getValue(props, `color`, "") : "#5f6368"
    } />
    </g>
    </svg>

  );
}

export default DropdownArrowSvgComponent;
